module.exports = __webpack_public_path__ + "static/media/bg-about-ripple3x.70fc6203.png";